var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectronicMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.71,
    height: 46.866,
    viewBox: "0 0 66.71 46.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12937",
    d: "M22.3 10.422H3.979a1.347 1.347 0 0 0-1.347 1.347v44.172a1.347 1.347 0 0 0 1.347 1.347H22.3a1.347 1.347 0 0 0 1.347-1.347V11.769a1.347 1.347 0 0 0-1.347-1.347zm-1.349 44.173H5.325v-41.48h15.626z",
    transform: "translate(-2.632 -10.422)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12938",
    d: "M64.066 14.367H23.939a1.347 1.347 0 0 0-1.347 1.347v30.818a1.347 1.347 0 0 0 1.347 1.347h16.215v5.94h-2.442a1.347 1.347 0 0 0 0 2.693h12.58a1.347 1.347 0 0 0 0-2.693H47.85v-5.94h16.216a1.347 1.347 0 0 0 1.347-1.347V15.714a1.346 1.346 0 0 0-1.347-1.347zM45.157 53.818h-2.31v-5.94h2.31zm17.562-8.633H25.286V17.06h37.433z",
    transform: "translate(1.298 -9.645)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12939",
    d: "M57.819 18.849h-29.4a1.347 1.347 0 0 0-1.345 1.351v20.086a1.347 1.347 0 0 0 1.347 1.347h29.4a1.347 1.347 0 0 0 1.347-1.347V20.2a1.346 1.346 0 0 0-1.349-1.351zM56.473 38.94H29.767v-17.4h26.706z",
    transform: "translate(2.181 -8.763)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12940",
    d: "M7.975 43.382h8.752a1.347 1.347 0 1 0 0-2.693H7.975a1.347 1.347 0 1 0 0 2.693z",
    transform: "translate(-1.845 -4.462)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12941",
    d: "M7.975 38.884h8.752a1.347 1.347 0 1 0 0-2.693H7.975a1.347 1.347 0 1 0 0 2.693z",
    transform: "translate(-1.845 -5.348)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12942",
    d: "M7.975 34.385h8.752a1.347 1.347 0 1 0 0-2.693H7.975a1.347 1.347 0 1 0 0 2.693z",
    transform: "translate(-1.845 -6.234)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12943",
    d: "M11.792 22.759a2.322 2.322 0 1 0-2.322-2.322 2.322 2.322 0 0 0 2.322 2.322z",
    transform: "translate(-1.286 -8.907)",
    style: {
      fill: "#333"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicMedical);
export default __webpack_public_path__ + "static/media/electronic-medical.b6aad147e8964ec346309591b2685be5.svg";
export { ForwardRef as ReactComponent };